const UTMIFY_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

/**
 * Carga el script oficial de UTMify (captura y persistencia de parámetros UTM).
 * Es idempotente: si el script ya está en el documento, no lo vuelve a insertar.
 */
export function loadUtmify(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[src="${UTMIFY_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTMIFY_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')

  document.head.appendChild(script)
}
